import React from 'react';

import { useAppSelector } from 'src/redux-file/hooks';
import { createAppTheme, createGhgTheme } from './theme';
import { selectEffectivePlatformPortal } from './selectors';

export function useEffectivePlatformPortal() {
  return useAppSelector(selectEffectivePlatformPortal);
}

export function useAppTheme() {
  const portal = useEffectivePlatformPortal();
  return React.useMemo(() => createAppTheme(portal), [portal]);
}

export function useGhgTheme() {
  const portal = useEffectivePlatformPortal();
  return React.useMemo(() => createGhgTheme(portal), [portal]);
}
